import { CustomerAddress, Region, Country, CheckoutStoreSelector } from '@bigcommerce/checkout-sdk'
import request from '../request'
import store from '../store'
import { setDefaultBillingAddress, setDefaultShippingAddress, setAddresses, setCountries } from '../store/actions'
import { storage, util } from '../utils'
import { addNewB3Address } from './addNewB3Address'
import Base64 from '../utils/base64'

const setCompanyCountries = async () => {
  const { list } = await request.api.getCountries()

  const formatCountries = list.map(({
    countryCode,
    countryName,
    states,
  }) => {
    const subdivisions = states.map(({
      stateCode,
      stateName,
    }) => ({
      code: stateCode,
      name: stateName
    }) as Region)
    return {
      code: countryCode,
      name: countryName,
      hasPostalCodes: true,
      requiresState: true,
      subdivisions,
    } as Country
  })

  store.dispatch(setCountries(formatCountries))
}

// const setAddressPermission = async () => {
//   const {
//     isAllow,
//     isEnabled,
//   } = await request.api.getAddressPermission()

//   storage.B3AddressBookActionPermission.setValue(isAllow)
//   storage.B3AddressBookIsEnabled.setValue(isEnabled)
// }

const setCompanyDefaultAddress = async (data: CheckoutStoreSelector) => {
  const companyId = storage.B3CompanyId.getValue()
  const { company } = store.getState()

  const {
    defaultBillingId,
    defaultShippingId,
    addresses: b2bAddresses,
  } = await request.api.getAddressesAll(companyId)

  // extraFields fieldName is cipherText
  const addresses: any = {}
  Object.keys(b2bAddresses).forEach((item: any) => {
    addresses[item] = b2bAddresses[item]
    const addressExtraFields = b2bAddresses[item]?.extraFields || []
    if (addressExtraFields?.length) {
      const newAddressExtraFields = addressExtraFields.map((address: any) => {
        const extraFieldsItem: any = {}
        extraFieldsItem.fieldName = Base64.encode(address.fieldName)
        extraFieldsItem.fieldValue = address.fieldValue
        return extraFieldsItem
      })

      addresses[item] = b2bAddresses[item]
      addresses[item].extraFields = newAddressExtraFields
    }
  })
  const formatAddress = util.formatAddresses(company.companyBasicInfo.companyName, addresses, data)

  const defaultShippingAddress = defaultShippingId ? formatAddress.find(address => address.id === +defaultShippingId) : {}
  const defaultBillingAddress = defaultBillingId ? formatAddress.find(address => address.id === +defaultBillingId) : {}

  defaultShippingId && store.dispatch(setDefaultShippingAddress(defaultShippingAddress as CustomerAddress))
  defaultBillingId && store.dispatch(setDefaultBillingAddress(defaultBillingAddress as CustomerAddress))

  store.dispatch(setAddresses(formatAddress as CustomerAddress[]))
}


const init = async (data: CheckoutStoreSelector) => {
  const { global: { isB3User } } = store.getState()
  if (!isB3User) return

  // if (!storage.B3AddressBookIsEnabled.getValue()) await setAddressPermission()
  // if (storage.B3AddressBookIsEnabled.getValue() !== constants.B3AddressBookPermission.isEnabled) return

  await setCompanyDefaultAddress(data)
  setCompanyCountries()
}

const convertAddress = (address: any) => {
  if (!address) return {}
  const newAddress = {
    customFields: address.customFields,
    firstName: address.firstName,
    lastName: address.lastName,
    company: address.company,
    address1: address.address1,
    address2: address.address2,
    city: address.city,
    stateOrProvince: address.stateOrProvince,
    stateOrProvinceCode: address.stateOrProvinceCode,
    countryCode: address.countryCode,
    postalCode: address.postalCode,
    phone: address.phone,
    country: address.country,
    shouldSaveAddress: address.shouldSaveAddress || '',
  }

  return newAddress
}

export default {
  init,
  addNewB3Address,
  convertAddress,
}